import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { finalize, Observable } from 'rxjs';
import { EDocumentationService } from 'src/app/data/e-documentation-service';
import { EFolderGridItemDto } from 'src/app/models/dtos/e-folder-grid-item-dto';
import { EFolderValidationResultDto } from 'src/app/models/dtos/e-folder-validation-result-dto';
import { FileService } from 'src/app/shared/services/file-service';
import { EDocumentDetailsComponent } from '../e-document-details/e-document-details.component';
import { NgxSpinnerService } from 'ngx-spinner';

export interface EFolderValidationDetailsComponentData {
  dto: EFolderGridItemDto;
  statusId: number;
}

@Component({
  selector: 'app-e-folder-validation-details',
  templateUrl: './e-folder-validation-details.component.html',
  styleUrls: ['./e-folder-validation-details.component.scss'],
  standalone: false
})
export class EFolderValidationDetailsComponent implements OnInit {

  dto: EFolderGridItemDto;

  displayedColumns: string[] = [
    'part',
    'document',
    'validationResult',
  ];

  constructor(
    private fileService: FileService,
    private eDocumentationService: EDocumentationService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) private data: EFolderValidationDetailsComponentData,
  ) {
    this.dto = data.dto;
  }

  validationResult$: Observable<EFolderValidationResultDto[]>

  ngOnInit(): void {
    this.spinner.show();
    this.validationResult$ = this.eDocumentationService.getValidationResult(this.dto.Id, this.data.statusId).pipe(finalize(() => this.spinner.hide()));
  }

  onPreviewFileBtnClick() {
    const endpoint = `e-documentations/files`;
    this.fileService.showFile(this.dto.OriginalFileName, this.dto.Id, endpoint);
  }

  onPreviewBtnClick(element: EFolderGridItemDto) {
    this.dialog.open(EDocumentDetailsComponent, {
      panelClass: 'details-dialog',
      data: {
        dto: element,
      },
    });
  }
}
